// Generic Title
export const PORTAL_TITLE = "Capital One Travel Portal";
// Flight Titles
export const FLIGHT_SEARCH_TITLE = "Search for a flight";
export const CHOOSE_DEPARTURE_TITLE = "Select a departure flight";
export const CHOOSE_RETURN_TITLE = "Select an return flight";
export const REVIEW_ITINERARY_TITLE = "Review Flight Itinerary";
export const FLIGHT_CHECKOUT_TITLE = "Complete Flight Booking";
export const BOOKING_CONFIRMATION_TITLE = "Booking Confirmation";
